import { Autocomplete, type AutocompleteProps, TextField } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { useAtomValue } from 'jotai';
import * as React from 'react';
import { completeTagsJotaiAtom } from '../jotai/atoms';

export interface AutocompleteTagsProps
  extends Partial<AutocompleteProps<string, true, true, true>> {
  teamId: string;
}

const styles = {
  autocomplete: {
    minWidth: 400,
    maxWidth: '100%'
  }
} as const;

export function AutocompleteTags({ teamId, ...props }: AutocompleteTagsProps) {
  const { sx, ...autocompleteProps } = props;
  const mergedSx: SxProps<Theme> = sx
    ? [styles.autocomplete, ...(Array.isArray(sx) ? sx : [sx])]
    : styles.autocomplete;
  // タグの一覧
  const tags = useAtomValue(completeTagsJotaiAtom(teamId));

  return (
    <Autocomplete
      multiple
      options={Array.from(tags)}
      freeSolo
      renderInput={params => (
        <TextField
          {...params}
          variant="standard"
          label="タグ"
          placeholder="タグを追加"
          helperText="エンターキーを押すと確定できます"
          fullWidth
        />
      )}
      disableClearable
      sx={mergedSx}
      {...autocompleteProps}
    />
  );
}
